module.exports = __webpack_public_path__ + "static/media/roastedjuicyberries.f5ccc49f.webp";